import React from 'react';
import { string, shape, arrayOf, number } from 'prop-types';
import { Field } from 'redux-form';
import Radium from 'radium';
import { WithLoading } from '@widergy/energy-ui';

import UTCheckList from '../../../../components/UTCheckList';
import { message } from '../../../../../utils/stringUtils';

import styles from './styles';

const header = [{ text: message('Signup:accountNumber') }, { text: message('Commons:address') }];

const formatList = list => list.map(item => ({ ...item, id: item.client_number }));

const RelatedAccounts = props => (
  <div style={styles.form}>
    <Field
      name="accountList"
      list={formatList(props.relatedAccounts)}
      component={UTCheckList}
      header={header}
      withoutLabel
      checked
    />
  </div>
);

RelatedAccounts.propTypes = {
  relatedAccounts: arrayOf(
    shape({
      id: number,
      address: string,
      client_number: string
    })
  )
};

export default WithLoading(props => props.loading)(Radium(RelatedAccounts));
